import type { MailAccountSummary } from "@/lib/types/mail";

/** Libellé affiché : nom personnalisé (BDD) ou adresse e-mail. */
export function getAccountDisplayLabel(
  account: Pick<MailAccountSummary, "email" | "displayName">
): string {
  const custom = account.displayName?.trim();
  return custom || account.email;
}

export function accountHasCustomDisplayLabel(
  account: Pick<MailAccountSummary, "email" | "displayName">
): boolean {
  const custom = account.displayName?.trim();
  return Boolean(custom && custom !== account.email);
}
